import { Grid, Link } from '@deere/fuel-react';
import { WithdrawEmployeeBidModal } from './admin-modals/WithdrawEmployeeBidModal';
import { EditEmployeeBidModal } from './admin-modals/EditEmployeeBidModal';
import { DateTime } from 'luxon';
import { PropTypes } from 'prop-types';
import styles from '../pages/Admin/ClosedJobDetails.module.css';
import {
    JOB_STATUS,
    WORKFORCE_JOB_BID_STATUS,
    JOB_PHASE,
    WATERLOO_BIDDING_GROUP_IDS,
} from '../constants';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Typography } from '@mui/material';

const ActiveWorkforceJobBidRow = ({
    jobNumber,
    workforceJobBid,
    refreshActiveList,
    jobStatus,
    jobPhase,
    refreshOpenings,
    updateJobBidList,
    biddingGroupId,
}) => {
    return (
        <Grid container className={styles.workforceJobBidRowInner}>
            <Grid item xs={6} className={styles.activeBiddersName}>
                <Link
                    href={`/employee-info/${workforceJobBid.racf}/${jobNumber}`}
                >
                    {workforceJobBid.name} - {workforceJobBid.racf}
                </Link>
            </Grid>
            {jobStatus === JOB_STATUS.ASSIGNED &&
                jobPhase === JOB_PHASE.CLOSED && (
                    <Grid
                        item
                        xs={6}
                        className={styles.workforceJobBidActionsSection}
                    >
                        <b>Successful for this job</b>
                    </Grid>
                )}
            <Grid item xs={6} className={styles.workforceJobBidActionsSection}>
                {jobStatus === JOB_STATUS.PENDING &&
                    jobPhase === JOB_PHASE.CLOSED && (
                        <EditEmployeeBidModal
                            bidderObj={workforceJobBid}
                            refreshActiveList={refreshActiveList}
                            refreshOpenings={refreshOpenings}
                            updateJobBidList={updateJobBidList}
                        />
                    )}{' '}
                {jobStatus === JOB_STATUS.PENDING &&
                    jobPhase === JOB_PHASE.WITHDRAWAL && (
                        <WithdrawEmployeeBidModal
                            bidderObj={workforceJobBid}
                            withdrawnBid={refreshActiveList}
                            updateJobBidList={updateJobBidList}
                        />
                    )}
            </Grid>
            <Grid
                item
                xs={12}
                className={styles.activeWorkforceJobBidInfoSection}
            >
                <span>
                    <b>Dept: </b>
                    {workforceJobBid.department}
                </span>
                <span>
                    <b>Current Classification: </b>
                    {workforceJobBid.classification}
                </span>
                <span>
                    <b>Seniority: </b>
                    {workforceJobBid.seniorityDate ? (
                        DateTime.fromISO(
                            workforceJobBid.seniorityDate
                        ).toFormat('LL/dd/yy')
                    ) : (
                        <span className={styles.nullSeniority}>
                            <ReportProblemIcon
                                className={styles.nullSeniorityAlertIcon}
                            />
                            {'Null'}
                        </span>
                    )}
                </span>
                {jobStatus === JOB_STATUS.PENDING &&
                    jobPhase === JOB_PHASE.CLOSED && (
                        <span>
                            <b>Restrictions: </b>
                            {workforceJobBid.hasRestrictions === 'Y'
                                ? 'Yes'
                                : 'No'}
                        </span>
                    )}
                {WATERLOO_BIDDING_GROUP_IDS.includes(biddingGroupId) && (
                    <span>
                        <b>Has Held Class: </b>
                        {workforceJobBid.workClass}
                    </span>
                )}
                <span>
                    <b>Ranked This Job: </b>
                    {workforceJobBid.preference} out of{' '}
                    {workforceJobBid.bidCount}
                </span>
            </Grid>
        </Grid>
    );
};

const WithdrawnWorkforceJobBidRow = ({ workforceJobBid, jobPhase }) => {
    return (
        <Grid container className={styles.workforceJobBidRowInner}>
            <Grid item xs={6}>
                <Typography variant="h3">
                    {workforceJobBid.name} - {workforceJobBid.racf}
                </Typography>
            </Grid>
            {jobPhase === JOB_PHASE.CLOSED && (
                <Grid
                    item
                    xs={6}
                    className={styles.workforceJobBidActionsSection}
                >
                    Bid Withdrawn
                </Grid>
            )}
            <Grid item xs={12} className={styles.withdrawnRow}>
                <span>
                    <b>Bid Withdrawn: </b>
                    {workforceJobBid.lastUpdatedAt
                        ? DateTime.fromISO(workforceJobBid.lastUpdatedAt)
                              .toFormat('LL/dd/yyyy, t')
                              .toLowerCase()
                        : 'NULL'}
                </span>
                <span>
                    <b>Withdrawn By: </b>
                    {workforceJobBid.lastUpdatedBy}
                </span>
                <span>
                    <b>Notes: </b>
                    {workforceJobBid.notes}
                </span>
            </Grid>
        </Grid>
    );
};

const UnsuccessfulWorkforceJobBidRow = ({ workforceJobBid, jobPhase }) => {
    return (
        <Grid container className={styles.workforceJobBidRowInner}>
            <Grid item xs={6}>
                <Typography variant="h3">
                    {workforceJobBid.name} - {workforceJobBid.racf}
                </Typography>
            </Grid>
            <Grid item xs={6} className={styles.workforceJobBidActionsSection}>
                Unsuccessful
            </Grid>
            <Grid
                item
                xs={12}
                className={styles.activeWorkforceJobBidInfoSection}
            >
                <span>
                    <b>Dept: </b>
                    {workforceJobBid.department}
                </span>
                <span>
                    <b>Current Classification: </b>
                    {workforceJobBid.classification}
                </span>
                <span>
                    <b>Seniority: </b>
                    {workforceJobBid.seniorityDate ? (
                        DateTime.fromISO(
                            workforceJobBid.seniorityDate
                        ).toFormat('LL/dd/yy')
                    ) : (
                        <span className={styles.nullSeniority}>
                            <ReportProblemIcon
                                className={styles.nullSeniorityAlertIcon}
                            />
                            {'Null'}
                        </span>
                    )}
                </span>
                <span>
                    <b>Ranked This Job: </b>
                    {workforceJobBid.preference} out of{' '}
                    {workforceJobBid.bidCount}
                </span>
            </Grid>
        </Grid>
    );
};

const RemovedWorkforceJobBidRow = ({ workforceJobBid }) => {
    return (
        <Grid container className={styles.workforceJobBidRowInner}>
            <Grid item xs={6}>
                <Typography variant="h3">
                    {workforceJobBid.name} - {workforceJobBid.racf}
                </Typography>
            </Grid>
            <Grid item xs={6} className={styles.workforceJobBidActionsSection}>
                Unsuccessful
            </Grid>
            <Grid item xs={12} className={styles.withdrawnRow}>
                <span>
                    <b>Marked as Unsuccessful: </b>
                    {workforceJobBid.lastUpdatedAt
                        ? DateTime.fromISO(
                              workforceJobBid.lastUpdatedAt
                          ).toFormat('LL/dd/yyyy, t')
                        : ' '}
                </span>
                <span>
                    <b>By: </b>
                    {workforceJobBid.lastUpdatedBy}
                </span>
                <span>
                    <b>Notes: </b>
                    {workforceJobBid.notes}
                </span>
            </Grid>
        </Grid>
    );
};

const WonOtherBidRow = ({ workforceJobBid }) => {
    return (
        <Grid container className={styles.workforceJobBidRowInner}>
            <Grid item xs={6}>
                <Typography variant="h3">
                    {workforceJobBid.name} - {workforceJobBid.racf}
                </Typography>
            </Grid>
            <Grid item xs={6} className={styles.workforceJobBidActionsSection}>
                Marked as Successful for {workforceJobBid.jobWon}
            </Grid>
            <Grid item xs={12}>
                <span>
                    <b>Marked as Successful for job {workforceJobBid.jobWon}</b>
                </span>
            </Grid>
        </Grid>
    );
};

export const WorkforceJobBidRow = ({
    workforceJobBid,
    jobNumber,
    refreshActiveList,
    jobStatus,
    jobPhase,
    refreshOpenings,
    updateJob,
    biddingGroupId,
}) => {
    const updateJobBidList = (response) => {
        updateJob((j) => {
            const updatedList = j.workforceJobBidList.filter(
                (b) => b.racf !== response.racf
            );
            const removedBid = j.workforceJobBidList.filter(
                (b) => b.racf === response.racf
            )[0];
            removedBid.lastUpdatedAt = response.updatedTs;
            removedBid.lastUpdatedBy = response.updatedBy;
            removedBid.status = response.status;
            removedBid.notes = response.notes;
            return {
                ...j,
                workforceJobBidList: [...updatedList, removedBid],
            };
        });
    };

    switch (workforceJobBid.status) {
        case WORKFORCE_JOB_BID_STATUS.SUBMITTED:
            return (
                <ActiveWorkforceJobBidRow
                    jobNumber={jobNumber}
                    workforceJobBid={workforceJobBid}
                    refreshActiveList={refreshActiveList}
                    jobStatus={jobStatus}
                    jobPhase={jobPhase}
                    refreshOpenings={refreshOpenings}
                    updateJobBidList={updateJobBidList}
                    biddingGroupId={biddingGroupId}
                />
            );
        //might not need this, as job bid status doesnt get set to "assigned" until after job is moved to Closed and Assigned
        case WORKFORCE_JOB_BID_STATUS.ASSIGNED:
            return (
                <ActiveWorkforceJobBidRow
                    jobNumber={jobNumber}
                    workforceJobBid={workforceJobBid}
                    refreshActiveList={refreshActiveList}
                    jobStatus={jobStatus}
                    jobPhase={jobPhase}
                    refreshOpenings={refreshOpenings}
                    updateJobBidList={updateJobBidList}
                    biddingGroupId={biddingGroupId}
                />
            );
        case WORKFORCE_JOB_BID_STATUS.WON_OTHER_BID:
            return <WonOtherBidRow workforceJobBid={workforceJobBid} />;
        case WORKFORCE_JOB_BID_STATUS.WITHDRAWN:
            return (
                <WithdrawnWorkforceJobBidRow
                    workforceJobBid={workforceJobBid}
                    jobPhase={jobPhase}
                />
            );
        case WORKFORCE_JOB_BID_STATUS.REMOVED:
            return (
                <RemovedWorkforceJobBidRow workforceJobBid={workforceJobBid} />
            );
        default:
            return (
                <UnsuccessfulWorkforceJobBidRow
                    workforceJobBid={workforceJobBid}
                    jobPhase={jobPhase}
                />
            );
    }
};

WorkforceJobBidRow.propTypes = {
    workforceJobBid: PropTypes.object.isRequired,
    jobNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    callback: PropTypes.func,
    jobPhase: PropTypes.string.isRequired,
    jobStatus: PropTypes.string.isRequired,
    updateJob: PropTypes.func,
    biddingGroupId: PropTypes.number,
};
